import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_ENRICHMENT_PROPERTIES_PANEL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_ENRICHMENT_PROPERTIES_PANEL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/EnrichmentPropertiesPanel')
};